import { fullscreenExcludeVideoOverlayStates } from "@/lib/constants";
import styles from "@/styles/Video.module.scss";
import { useCallback } from "react";
import NextEpisode from "./NextEpisode";
import classnames from "classnames";

export default function FullScreenOverlay({
  state,
  prevState,
  error,
  watch,
  player,
  fullScreen,
}) {
  const handleFirst = useCallback(() => {
    state.updateResumePoint(0);
  }, []);

  if (!state.overlay && !error) return null;
  if (fullScreen) {
    if (state.reason === "next_episode") {
      if (watch?.nextEpisode) {
        return (
          <div className={classnames(styles.overlay, styles.fullScreen)}>
              <NextEpisode className={styles.fullScreen} watch={watch} state={state} />
          </div>
        );
      } else return null;
    } else if (state.reason === "resume") {
      // Windows Chromeでレジュームありの場合視聴開始しないので、視聴開始する
      handleFirst();
    } else if (
      (!!state.reason &&
        fullscreenExcludeVideoOverlayStates.includes(state.reason)) ||
      (!!prevState.reason &&
        fullscreenExcludeVideoOverlayStates.includes(prevState.reason))
    ) {
      player?.exitFullscreen();
    }
  }
  return null;
}
